export const messages = {
  en: {
    service: {
      search: {
        title: 'Search Condition',
        serviceId: 'serviceId',
        serviceCode: 'serviceCode',
        name: 'name',
        url: 'url',
        method: 'method',
        timeout: 'timeout',
        retryCount: 'retryCount',
        placeholder: 'Please enter service name'
      },
      list: {
        title: 'service List'
      },
      dialog: {
        addTitle: 'Add Service',
        editTitle: 'Edit Service',
        delTitle: 'Delete Service',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        serviceId: 'serviceId',
        serviceCode: 'serviceCode',
        name: 'name',
        url: 'url',
        method: 'method',
        timeout: 'timeout',
        retryCount: 'retryCount',
      },
      table: {
        serviceId: 'serviceId',
        serviceCode: 'serviceCode',
        name: 'name',
        url: 'url',
        method: 'method',
        timeout: 'timeout',
        retryCount: 'retryCount',
      },
      validate: {
        serviceId: 'Please enter serviceId',
        serviceCode: 'Please enter serviceCode',
        name: 'Please enter name',
        timeout: 'Please enter timeout',
        retryCount: 'Please enter retryCount',
      },
      add: {
        success: 'Add Service success'
      },
      edit: {
        success: 'Edit Service success'
      },
      delete: {
        success: 'Delete Service success',
        confirm: 'Are you sure to delete this service?'
      },
      fetchError: 'Failed to fetch service list'
    }
  },
  zh: {
    service: {
      search: {
        title: '查询条件',
        serviceId: '服务ID',
        serviceCode: '服务编码',
        name: '服务名称',
        url: '目标地址',
        method: '调用方式',
        timeout: '超时时间',
        retryCount: '重试次数',
        placeholder: '请输入服务名称'
      },
      list: {
        title: '服务列表'
      },
      dialog: {
        addTitle: '添加服务',
        editTitle: '编辑服务',
        delTitle: '删除服务',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        serviceId: '服务ID',
        serviceCode: '服务编码',
        name: '服务名称',
        url: '目标地址',
        method: '调用方式',
        timeout: '超时时间',
        retryCount: '重试次数',
      },
      table: {
        serviceId: '服务ID',
        serviceCode: '服务编码',
        name: '服务名称',
        url: '目标地址',
        method: '调用方式',
        timeout: '超时时间',
        retryCount: '重试次数',
      },
      validate: {
        serviceId: '请输入服务ID',
        serviceCode: '请输入服务编码',
        name: '请输入服务名称',
        timeout: '请输入超时时间',
        retryCount: '请输入重试次数',
      },
      add: {
        success: '添加服务成功'
      },
      edit: {
        success: '编辑服务成功'
      },
      delete: {
        success: '删除服务成功',
        confirm: '确认删除该服务吗？'
      },
      fetchError: '获取服务列表失败'
    }
  },
  'zh-TW': {
    service: {
      search: {
        title: '查詢條件',
        serviceId: '服務ID',
        serviceCode: '服務編碼',
        name: '服務名稱',
        url: '目標地址',
        method: '調用方式',
        timeout: '超時時間',
        retryCount: '重試次數',
        placeholder: '請輸入服務名稱'
      },
      list: {
        title: '服務列表'
      },
      dialog: {
        addTitle: '添加服務',
        editTitle: '編輯服務',
        delTitle: '刪除服務',
        cancel: '取消',
        confirm: '確定'
      },
      form: {
        serviceId: '服務ID',
        serviceCode: '服務編碼',
        name: '服務名稱',
        url: '目標地址',
        method: '調用方式',
        timeout: '超時時間',
        retryCount: '重試次數',
      },
      table: {
        serviceId: '服務ID',
        serviceCode: '服務編碼',
        name: '服務名稱',
        url: '目標地址',
        method: '調用方式',
        timeout: '超時時間',
        retryCount: '重試次數',
      },
      validate: {
        serviceId: '請輸入服務ID',
        serviceCode: '請輸入服務編碼',
        name: '請輸入服務名稱',
        timeout: '請輸入超時時間',
        retryCount: '請輸入重試次數',
      },
      add: {
        success: '添加服務成功'
      },
      edit: {
        success: '編輯服務成功'
      },
      delete: {
        success: '刪除服務成功',
        confirm: '確認刪除該服務嗎？'
      },
      fetchError: '獲取服務列表失敗'
    }
  }
}